import _jsx from "@babel/runtime/helpers/jsx";
var _HotCar, _NewlyListed, _ReducedPrice;
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { formatCurrency } from '@atc/string-fns';
import { InventoryImage, NewlyListed, ReducedPrice, HotCar } from 'reaxl-molecules';
import { CheckboxWithVisual, Text } from 'reaxl';

/**
 *
 * It takes the badge booleans from listing and returns the respective badge
 *
 */
function Badge(_ref) {
  let {
    isHot,
    isNewlyListed,
    isReducedPrice
  } = _ref;
  if (isHot) {
    return _HotCar || (_HotCar = /*#__PURE__*/_jsx(HotCar, {}));
  }
  if (isNewlyListed) {
    return _NewlyListed || (_NewlyListed = /*#__PURE__*/_jsx(NewlyListed, {}));
  }
  if (isReducedPrice) {
    return _ReducedPrice || (_ReducedPrice = /*#__PURE__*/_jsx(ReducedPrice, {}));
  }
  return null;
}

/**
 *
 * Generates a checkbox with lisitng image and listing information
 *
 */
function SelectableInventorySnapshot(_ref2) {
  let {
    checked = false,
    listing = {},
    onChange
  } = _ref2;
  const {
    images: {
      primary,
      sources
    } = {},
    owner: {
      name
    } = {},
    pricingDetail: {
      incentive,
      msrp,
      noPriceLabel,
      salePrice
    } = {},
    title
  } = listing;
  const imageIndex = primary || 0;
  const imageSrc = sources?.[imageIndex].src;
  const [imageIsBroken, setImageIsBroken] = useState(typeof imageSrc !== 'string' || imageSrc === '');
  let priceStyling = {
    size: 400,
    weight: 'ultra-bold'
  };
  const listingPrice = incentive || salePrice || msrp;
  let formattedListingPrice = listingPrice ? formatCurrency(listingPrice) : '';
  if (!formattedListingPrice) {
    formattedListingPrice = noPriceLabel;
    priceStyling = {
      size: 300,
      weight: 'bold'
    };
  }
  const label = /*#__PURE__*/_jsx("div", {
    className: "margin-vertical-1"
  }, void 0, /*#__PURE__*/React.createElement(Badge, listing), /*#__PURE__*/_jsx(Text, {
    size: 300,
    componentClass: "div",
    className: "margin-top-1"
  }, void 0, title), /*#__PURE__*/React.createElement(Text, priceStyling, formattedListingPrice), /*#__PURE__*/_jsx(Text, {
    size: 200,
    color: "subdued",
    componentClass: "div"
  }, void 0, name));
  return /*#__PURE__*/_jsx(CheckboxWithVisual, {
    checked: checked,
    label: label,
    onChange: onChange,
    uiContext: "landscape",
    withCheckmark: true,
    image: /*#__PURE__*/_jsx(InventoryImage, {
      src: imageIsBroken ? undefined : imageSrc,
      lazyLoad: true,
      sizes: {
        ...(imageIsBroken && {
          minWidth: 100
        }),
        width: 100,
        height: 75
      },
      onError: () => setImageIsBroken(true)
    })
  });
}
SelectableInventorySnapshot.displayName = 'SelectableInventorySnapshot';
export default SelectableInventorySnapshot;